import { configureStore } from '@reduxjs/toolkit'
import authReducer from './Slices/authSlice'
import productsReducer from './Slices/productSlice'
import blogsReducer from './Slices/blogSlice'
import eventsReducer from './Slices/eventsSlice'
import testimonialsReducer from './Slices/testimonialsSlice'
import subscribersReducer from './Slices/newsletterSlice'
import contactUsReducer from './Slices/contactusSlice'

export default configureStore({
    reducer: {
        auth: authReducer,
        productsData: productsReducer,
        blogsData: blogsReducer,
        eventsData: eventsReducer,
        testimonialsData: testimonialsReducer,
        subscribersData: subscribersReducer,
        contactusData: contactUsReducer,

    }
})